export class PasswordCredentialsService {
    /* @ngInject */
    constructor($http, egUrlService, $window, $q) {
        this.$http = $http;
        this.egUrlService = egUrlService;
        this.$window = $window;
        this.$q = $q;
    }

    getUserSecurityContext() {
        var url = this.egUrlService.url('/authentication/credentials/password/securityContext');
        return this.$http.get(url)
            .then(response => response.data)
            .catch(this.requestError.bind(this));
    }

    changePassword(changeCredentialsData) {
        var url = this.egUrlService.url('/authentication/credentials/password/changePassword');
        return this.$http.post(url, changeCredentialsData)
            .then(response => response.data)
            .catch(this.requestError.bind(this));
    }

    activateUser(username, password, uuid, email) {
        var url = this.egUrlService.url('/authentication/credentials/password/activate');
        return this.$http.post(url,
            {
                'username': username,
                'password': password,
                'email': email
            },
            {
                params: { 'deviceTokenId': uuid }
            })
            .then(response => response.data)
            .catch(this.requestError.bind(this));
    }

    getApprovalForUsername() {
        var url = this.egUrlService.url('/authentication/verifications/username/approved');
        return this.$http.post(url)
            .then(response => response.data)
            .catch(this.requestError.bind(this));
    }

    requestError(response) {
        return this.$q.reject(response.data);
    }

}
